import React, { Fragment, useContext, useEffect, useState } from 'react'
import LogoutIcon from 'assets/images/new-images/logout.svg'
import {
  Breadcrumb,
  Button,
  Col,
  Layout,
  Popover,
  Row,
  Select,
  Tag,
} from 'antd'
import { AppContext } from 'AppContext'
import {
  EyeOutlined,
  QuestionCircleOutlined,
  TeamOutlined,
  UserOutlined,
} from '@ant-design/icons'
import HomeNewIcon from 'assets/images/new-images/homeIcon.svg'
import client from 'apollo'
import _omit from 'lodash/omit'
import _map from 'lodash/map'
import _get from 'lodash/get'
import NotificationIcon from 'assets/images/new-images/notification.svg'
import AdvisoryIcon from 'assets/images/new-images/advisory-notification-icon.png'
import PendingAdvisoryIcon from 'assets/images/new-images/pending-amc-icon.png'

import { GET_STRATEGY_LIST } from 'modules/Settings/graphql/Queries'
import { GET_GROUPS } from 'modules/Groups/graphql/Queries'
// import history from 'CustomHistory'
import openNotification from 'utils/Notification'
import { CHANGE_PASSWORD, UPDATE_USER } from 'modules/Users/graphql/Mutations'
import ChangePassword from 'components/ChangePassword'
import { READ_NOTIFICATION } from 'auth/graphql/Mutations'
import { GET_ALL_NOTIFICATION_FOR_CLIENT } from 'auth/graphql/Queries'
import moment from 'moment'
import { GET_USERS } from 'modules/Users/graphql/Queries'
import { useQuery } from '@apollo/react-hooks'
import TicketIcon from 'assets/images/new-images/ticket-red-notification.svg'
import { useHistory } from 'react-router-dom'

const { Header } = Layout
const { Option, OptGroup } = Select

const HeaderNew = () => {
  const [groups, setGroups] = useState([])
  const [strategyList, setStrategyList] = useState([])
  const [visibleMenu, setVisibleMenu] = useState(false)
  const [visible, setVisible] = useState(false)
  const [loadMoreLoading, setLoadMoreLoading] = useState(false)
  const [readAllLoading, setReadAllLoading] = useState(false)
  const [readLoading, setReadLoading] = useState({})
  const [userData, setUserData] = useState([])
  const [userDataLoading, setUserDataLoading] = useState(false)
  const [selectedGroupId, setSelectedGroupId] = useState(null)
  const [selectedUserId, setSelectedUserId] = useState(null)
  const history = useHistory()

  const {
    dispatch,
    state: {
      showFAQScreen,
      currentUser,
      clientRiskScore,
      MaintenanceStatus: { type, message, isActive },
      isClient,
      isMobile,
      allNotificationsForClient: { notReadCount, count, notifications },
    },
  } = useContext(AppContext)

  const [isNotificationOpen, setIsNotificationOpen] = useState(false)
  const [selectedUserName, setSelectedUserName] = useState('')
  const [open, setOpen] = useState(false)

  // Accessibility Toolbar States & Handlers
  const [aswLang, setAswLang] = useState('en')
  const [aswStates, setAswStates] = useState({
    fontSize: 1.0,
    contrast: '',
  })

  useEffect(() => {
    const loadAswSettings = () => {
      try {
        const stored = localStorage.getItem('asw-user-settings')
        if (stored) {
          const parsed = JSON.parse(stored)
          if (parsed) {
            if (parsed.lang) setAswLang(parsed.lang)
            if (parsed.states) {
              setAswStates({
                fontSize: parsed.states.fontSize || 1.0,
                contrast: parsed.states.contrast || '',
              })
            }
          }
        }
      } catch (e) {
        console.warn('Failed to load asw settings in header:', e)
      }
    }
    loadAswSettings()
    window.addEventListener('asw-update-settings', loadAswSettings)
    return () => {
      window.removeEventListener('asw-update-settings', loadAswSettings)
    }
  }, [])

  const DEFAULT_ASW_STATES = {
    fontSize: 1.0,
    'font-weight': false,
    'line-height': false,
    'letter-spacing': false,
    'readable-font': false,
    'highlight-links': false,
    'highlight-title': false,
    'stop-animations': false,
    'hide-images': false,
    'image-tooltips': false,
    'readable-guide': false,
    'reading-mask': false,
    'big-cursor': false,
    'screen-reader': false,
    'page-structure': false,
    'super-focus': false,
    contrast: ''
  }

  const updateAswSetting = (updater) => {
    try {
      const stored = localStorage.getItem('asw-user-settings')
      let parsed = { states: { ...DEFAULT_ASW_STATES }, lang: 'en', activeProfile: '' }
      if (stored) {
        const temp = JSON.parse(stored)
        if (temp) {
          parsed = {
            ...parsed,
            ...temp,
            states: { ...DEFAULT_ASW_STATES, ...temp.states }
          }
        }
      }
      const updated = updater(parsed)
      localStorage.setItem('asw-user-settings', JSON.stringify(updated))
      window.dispatchEvent(new CustomEvent('asw-update-settings'))
    } catch (e) {
      console.error('Failed to update accessibility setting:', e)
    }
  }

  const handleAswLangChange = (newLang) => {
    // Always persist the preference first
    updateAswSetting(curr => ({ ...curr, lang: newLang }))

    if (newLang === 'en') {
      // ── ENGLISH: wipe cookies and reload to show the original page ──────────
      // This is the ONLY guaranteed way to fully remove Google Translate's overlay.
      // In-place API calls (showOriginal, doGTranslate) are unreliable in this setup.
      try {
        const host = window.location.hostname;
        const paths = ['/', '/login', '/pending-advisory'];
        const domains = [null, host, `.${host.split('.').slice(-2).join('.')}`];
        paths.forEach(p => {
          domains.forEach(d => {
            const base = `googtrans=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${p}`;
            document.cookie = d ? `${base}; domain=${d}` : base;
          });
        });
      } catch (e) { console.warn('Cookie clear error:', e); }

      // Reload without any translation cookie — page comes back as original English
      window.location.reload();
      return;
    }

    // ── NON-ENGLISH: set cookie and trigger in-place translation ─────────────
    try {
      const d = new Date();
      d.setTime(d.getTime() + 365 * 24 * 60 * 60 * 1000);
      const base = `googtrans=/en/${newLang}; path=/; expires=${d.toUTCString()}`;
      document.cookie = base;
      const host = window.location.hostname;
      document.cookie = `${base}; domain=${host}`;
      const parts = host.split('.');
      if (parts.length > 1) document.cookie = `${base}; domain=.${parts.slice(-2).join('.')}`;
    } catch (e) { console.warn('Cookie set error:', e); }

    // Cancel any previous pending retry
    if (window._aswTranslateInterval) {
      clearInterval(window._aswTranslateInterval);
      window._aswTranslateInterval = null;
    }

    // Wake up GTranslate lazy loader
    const wrapper = document.querySelector('.gtranslate_wrapper');
    if (wrapper) {
      wrapper.dispatchEvent(new Event('pointerenter'));
      wrapper.dispatchEvent(new Event('focusin'));
    }

    let done = false;
    const combo = document.querySelector('.goog-te-combo');
    if (combo) {
      combo.value = newLang;
      combo.dispatchEvent(new Event('change', { bubbles: true }));
      done = true;
    }
    const sel = document.querySelector('.gtranslate_wrapper select, .gt_selector');
    if (sel?.options?.length > 0) {
      const opt = Array.from(sel.options).find(o => o.value === newLang || o.value.endsWith(`|${newLang}`));
      if (opt) { sel.value = opt.value; sel.dispatchEvent(new Event('change', { bubbles: true })); done = true; }
    }

    if (!done) {
      let r = 0;
      window._aswTranslateInterval = setInterval(() => {
        const wrap = document.querySelector('.gtranslate_wrapper');
        if (wrap) { wrap.dispatchEvent(new Event('pointerenter')); wrap.dispatchEvent(new Event('focusin')); }
        const c = document.querySelector('.goog-te-combo');
        if (c) {
          c.value = newLang;
          c.dispatchEvent(new Event('change', { bubbles: true }));
          clearInterval(window._aswTranslateInterval);
          window._aswTranslateInterval = null;
          return;
        }
        // This deployment's widget (gtranslate.net's dropdown.js) exposes a
        // .gt_selector, not Google's own .goog-te-combo, so the retry loop must
        // also recognize it — otherwise a slow-loading widget on first click
        // silently never translates the page.
        const s = document.querySelector('.gtranslate_wrapper select, .gt_selector');
        if (s?.options?.length > 0) {
          const opt = Array.from(s.options).find((o) => o.value === newLang || o.value.endsWith(`|${newLang}`));
          if (opt) {
            s.value = opt.value;
            s.dispatchEvent(new Event('change', { bubbles: true }));
            clearInterval(window._aswTranslateInterval);
            window._aswTranslateInterval = null;
            return;
          }
        }
        if (++r > 30) { clearInterval(window._aswTranslateInterval); window._aswTranslateInterval = null; }
      }, 400);
    }
  }

  const handleAswFontSize = (action) => {
    updateAswSetting(curr => {
      let size = curr.states.fontSize || 1.0
      if (action === 'plus') {
        size = Math.min(2.0, size + 0.1)
      } else if (action === 'minus') {
        size = Math.max(0.7, size - 0.1)
      } else {
        size = 1.0
      }
      return {
        ...curr,
        activeProfile: '',
        states: {
          ...curr.states,
          fontSize: Number(size.toFixed(2))
        }
      }
    })
  }

  const handleAswContrastToggle = () => {
    updateAswSetting(curr => {
      let currentContrast = curr.states.contrast || ''
      let nextContrast = ''
      if (currentContrast === '') nextContrast = 'dark-contrast'
      else if (currentContrast === 'dark-contrast') nextContrast = 'light-contrast'
      else nextContrast = ''
      
      return {
        ...curr,
        activeProfile: '',
        states: {
          ...curr.states,
          contrast: nextContrast
        }
      }
    })
  }


  const renderAswToolbar = () => {
    const desktopView = (
      <div className='asw-header-toolbar' aria-label='Accessibility Controls'>
        <select
          name='lang'
          value={aswLang}
          onChange={(e) => handleAswLangChange(e.target.value)}
          className='asw-toolbar-select language-switcher notranslate'
          aria-label='Select Language'
          translate="no"
        >
          <option value="" disabled translate="no">Select Language</option>
          <option value="en" translate="no">English</option>
          <option value="hi" translate="no">Hindi</option>
          <option value="mr" translate="no">Marathi</option>
          <option value="bn" translate="no">Bengali</option>
          <option value="gu" translate="no">Gujarati</option>
          <option value="kn" translate="no">Kannada</option>
          <option value="ml" translate="no">Malayalam</option>
          <option value="ne" translate="no">Nepali</option>
          <option value="pa" translate="no">Punjabi</option>
          <option value="sd" translate="no">Sindhi</option>
          <option value="ta" translate="no">Tamil</option>
          <option value="te" translate="no">Telugu</option>
          <option value="ur" translate="no">Urdu</option>
        </select>
        <button
          onClick={() => handleAswFontSize('plus')}
          className={`asw-toolbar-btn ${aswStates.fontSize > 1.0 ? 'active' : ''}`}
          title='Increase text size (A+)'
          aria-label='Increase text size (A+)'
        >
          A+
        </button>
        <button
          onClick={() => handleAswFontSize('minus')}
          className={`asw-toolbar-btn ${aswStates.fontSize < 1.0 ? 'active' : ''}`}
          title='Decrease text size (A-)'
          aria-label='Decrease text size (A-)'
        >
          A-
        </button>
        <button
          onClick={() => handleAswFontSize('reset')}
          className={`asw-toolbar-btn ${aswStates.fontSize === 1.0 ? 'active' : ''}`}
          title='Reset text size (A)'
          aria-label='Reset text size (A)'
        >
          A
        </button>
        <button
          onClick={handleAswContrastToggle}
          className={`asw-toolbar-btn ${aswStates.contrast !== '' ? 'active' : ''}`}
          title='Toggle high contrast mode'
          aria-label='Toggle high contrast mode'
        >
          Contrast
        </button>
      </div>
    );

    const mobilePopoverContent = (
      <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', padding: '5px' }}>
        <select
          name='lang'
          value={aswLang}
          onChange={(e) => handleAswLangChange(e.target.value)}
          className='asw-toolbar-select language-switcher notranslate'
          aria-label='Select Language'
          translate="no"
          style={{ width: '100%', padding: '5px', borderRadius: '4px', border: '1px solid #ccc' }}
        >
          <option value="" disabled translate="no">Select Language</option>
          <option value="en" translate="no">English</option>
          <option value="hi" translate="no">Hindi</option>
          <option value="mr" translate="no">Marathi</option>
          <option value="bn" translate="no">Bengali</option>
          <option value="gu" translate="no">Gujarati</option>
          <option value="kn" translate="no">Kannada</option>
          <option value="ml" translate="no">Malayalam</option>
          <option value="ne" translate="no">Nepali</option>
          <option value="pa" translate="no">Punjabi</option>
          <option value="sd" translate="no">Sindhi</option>
          <option value="ta" translate="no">Tamil</option>
          <option value="te" translate="no">Telugu</option>
          <option value="ur" translate="no">Urdu</option>
        </select>
        <div style={{ display: 'flex', gap: '5px', justifyContent: 'space-between' }}>
          <Button size="small" onClick={() => handleAswFontSize('plus')} type={aswStates.fontSize > 1.0 ? 'primary' : 'default'}>A+</Button>
          <Button size="small" onClick={() => handleAswFontSize('reset')} type={aswStates.fontSize === 1.0 ? 'primary' : 'default'}>A</Button>
          <Button size="small" onClick={() => handleAswFontSize('minus')} type={aswStates.fontSize < 1.0 ? 'primary' : 'default'}>A-</Button>
        </div>
        <Button size="small" onClick={handleAswContrastToggle} type={aswStates.contrast !== '' ? 'primary' : 'default'} style={{ width: '100%' }}>Contrast</Button>
      </div>
    );

    if (isMobile) {
      return (
        <Popover content={mobilePopoverContent} trigger="click" placement="bottomRight">
          <Button style={{ marginRight: '10px', padding: '0 8px' }}>Aa / Lang</Button>
        </Popover>
      );
    }

    return desktopView;
  }

  const IndividualSteps = {
    SELECT_USER_TYPE: 'Client Basic Details',
    LOGIN_CREATED: 'Select User Type',
    CLIENT_PROFILE_1: 'Client Profile',
    CLIENT_PROFILE_2: 'Kyc Document',
    KYC_DOC: 'Risk Profile Assessment',
    RISK_PROFILE: 'Summary',
    SUMMARY: 'Investment Planning',
    //KYC_FORM: 'Kyc E-Sign',
    INVESTMENT_PLANNING: 'Agreement Sign',
    AGREEMENT_SIGN: 'E-Mandate Registration',
    E_MANDATE: 'Congratulations !!!!',
    CONGRATULATION: 'Pending Advisory',
    DONE: 'Dashboard',
  }

  const getIndividualStepTitle = (step) => {
    if (!currentUser?.isPanCardIndividual) {
      return nonIndividualSteps[step]
    }
    if (step === 'CLIENT_PROFILE_2' && currentUser?.cvlStatus) {
      return 'Risk Profile Assessment'
    }
    return IndividualSteps[step]
  }
  const nonIndividualSteps = {
    LOGIN_CREATED: 'Select User Type',
    SELECT_USER_TYPE: 'Client Basic Details',
    CLIENT_PROFILE_1: 'Client Profile',
    CLIENT_PROFILE_2: 'Risk Profile Assessment',
    RISK_PROFILE: 'Summary',
    SUMMARY: 'Investment Planning',
    INVESTMENT_PLANNING: 'Courier Instruction',
    DONE: 'Dashboard',
  }

  const messageStyle = {
    textAlign: 'center',
    fontSize: '15px',
    fontWeight: '500',
    marginTop: '10px',
    backgroundColor: '#fff',
    height: '20',
  }
  if (type === 'SUCCESS') {
    messageStyle.color = '#135200'
  } else if (type === 'WARNING') {
    messageStyle.color = '#873800'
  } else if (type === 'INFO') {
    messageStyle.color = '#003a8c'
  } else if (type === 'DANGER') {
    messageStyle.color = '#a8071a'
  }

  const showFilters = _get(history, 'location.pathname') === '/' && !isClient

  useEffect(() => {
    dispatch({ type: 'SELECTED_GROUP', data: undefined })
    dispatch({ type: 'SELECTED_STRATEGY', data: 'ILTS' })
  }, [dispatch, showFilters])

  useEffect(() => {
    if (showFilters) {
      client
        .query({ query: GET_STRATEGY_LIST, fetchPolicy: 'cache-first' })
        .then((res) => {
          if (_get(res, 'data.getStrategyList')) {
            setStrategyList(_get(res, 'data.getStrategyList'))
          }
        })
    }
  }, [showFilters])

  const { data } = useQuery(GET_USERS, {
    fetchPolicy: 'cache-first',
  })
  const totalCount = data?.getUsers?.count
  useEffect(() => {
    setUserDataLoading(true)
    client
      .query({
        query: GET_USERS,
        variables: { limit: totalCount },
        fetchPolicy: 'cache-first',
      })
      .then((res) => {
        setUserDataLoading(false)
        setUserData(res?.data?.getUsers?.users)
      })
  }, [totalCount])
  useEffect(() => {
    if (showFilters) {
      setUserDataLoading(true)
      client
        .query({
          query: GET_GROUPS,
          variables: { limit: 300, isFromDashBoard: true },
          fetchPolicy: 'cache-first',
        })
        .then((res) => {
          setUserDataLoading(false)
          if (_get(res, 'data.getGroups.groups')) {
            setGroups(_get(res, 'data.getGroups.groups'))
          }
        })
    }
  }, [showFilters])

  // function returnGroups() {
  //   return _map(groups, (group, key) => {
  //     const { id, name } = group
  //     return (
  //       <Option value={id} key={key}>
  //         {name}
  //       </Option>
  //     )
  //   })
  // }
  function returnGroups() {
    return userData && Object.keys(userData).length > 0
      ? _map(userData, (users, groupName) => (
          <OptGroup
            label={
              <div
                onClick={() => {
                  dispatch({
                    type: 'SELECTED_ASSOCIATE',
                    data: users?.id ? parseInt(users?.id) : undefined,
                  })
                  dispatch({
                    type: 'SELECTED_GROUP',
                    data: undefined,
                  })
                  setSelectedUserName(`${users?.firstName} ${users?.lastName}`)
                  setSelectedUserId(users?.id)
                  setSelectedGroupId('')
                  setOpen(false)
                }}
                style={{
                  cursor: 'pointer',
                  fontSize: '14px',
                  backgroundColor:
                    selectedUserId === users?.id ? '#af00001a' : '',
                  color: selectedUserId === users?.id ? '#af0000' : '#545454',
                }}
              >
                <span
                  style={{
                    paddingLeft: '2px',
                    display: 'flex',
                    alignItems: 'baseline',
                  }}
                >
                  <UserOutlined
                    style={{
                      marginRight: '5px',
                      color: '#af0000',
                      fontSize: '12px',
                    }}
                  />
                  {`${users?.firstName} ${users?.lastName}`}
                </span>
              </div>
            }
            key={groupName}
          >
            {groups
              ?.filter((item) => item?.createdBy?.id === users?.id)
              ?.map((item) => (
                <Option
                  title={item?.name}
                  value={item?.id}
                  key={item?.id}
                  style={{
                    backgroundColor:
                      selectedGroupId === item?.id ? '#af00001a' : '',
                    color: selectedGroupId === item?.id ? '#af0000' : '',
                  }}
                >
                  <TeamOutlined
                    style={{
                      marginRight: '5px',
                      color: '#af0000',
                      fontSize: '12px',
                    }}
                  />
                  <span>{item?.name}</span>
                </Option>
              ))}
          </OptGroup>
        ))
      : groups
          ?.filter((item) => item?.createdBy?.id === currentUser?.id)
          ?.map((group) => (
            <Option
              title={group?.name}
              value={group?.id}
              key={group?.id}
              style={{
                backgroundColor:
                  selectedGroupId === group?.id ? '#af00001a' : '',
                color: selectedGroupId === group?.id ? '#af0000' : '',
              }}
            >
              <TeamOutlined
                style={{
                  marginRight: '5px',
                  color: '#af0000',
                  fontSize: '12px',
                }}
              />
              <span>{group?.name}</span>
            </Option>
          ))
  }

  const userMenuOptions = (
    <ul className='gx-user-popover'>
      <li style={{ display: 'flex', gap: '10px' }}>
        <UserOutlined
          style={{
            fontSize: '20px',
            display: `${isMobile ? 'flex' : 'none'}`,
            gap: '10px',
          }}
        />
        <div className='header-new-user-info-mobile'>
          <div className='header-new-user-name'>
            {currentUser?.role === 'ADMIN'
              ? currentUser?.firstName
              : !currentUser?.isPanCardIndividual &&
                currentUser?.nameOfApplicant
              ? currentUser?.nameOfApplicant
              : currentUser?.firstName && currentUser?.lastName
              ? `${currentUser?.firstName} ${currentUser?.lastName}`
              : ''}
          </div>
          {currentUser?.clientCode ? (
            <div className='header-new-user-code'>
              {currentUser?.clientCode}
            </div>
          ) : currentUser?.currentType === 'Master Associate' ? (
            <div className='header-new-user-code'>
              {currentUser?.currentType}
            </div>
          ) : (
            <div className='header-new-user-code'>
              {currentUser?.role === 'SALES_EXECUTIVE'
                ? 'AIF_SALES_EXECUTIVE'.split('_')?.join(' ')
                : currentUser?.role.split('_')?.join(' ')}
            </div>
          )}
        </div>
      </li>
      <hr
        style={{ margin: '5px 0', display: `${isMobile ? 'flex' : 'none'}` }}
      />
      <li
        style={{ display: 'flex', gap: '10px' }}
        onClick={() => {
          setVisibleMenu(false)
          history.push('/profile')
        }}
      >
        <i className='icon icon-avatar' style={{ fontSize: '20px' }}></i>
        <span>Profile</span>
      </li>
      <li
        style={{ display: 'flex', gap: '10px' }}
        onClick={() => {
          setVisibleMenu(false)
          handleVisible()
        }}
      >
        <EyeOutlined style={{ fontSize: '20px' }} /> Change Password
      </li>
      {currentUser?.role === 'CLIENT' ? (
        <li
          style={{ display: `${isMobile ? 'flex' : 'none'}`, gap: '10px' }}
          onClick={() => {
            if (currentUser?.completedSteps !== 'DONE') {
              dispatch({ type: 'SHOW_FAQ_SCREEN', data: true })
            } else {
              history.push('/faqs')
            }
          }}
        >
          <QuestionCircleOutlined
            style={{ fontSize: '20px', height: '26px' }}
          />
          Help
        </li>
      ) : (
        ''
      )}
      <li
        style={{ display: `${isMobile ? 'flex' : 'none'}`, gap: '10px' }}
        onClick={() => {
          client
            .mutate({
              mutation: UPDATE_USER,
              variables: {
                data: {
                  token: null,
                  tokenExpiration: null,
                },
                id: parseInt(currentUser.id),
              },
            })
            .then((res) => {
              window.location.href = '/logout'
            })
        }}
      >
        <img src={LogoutIcon} style={{ height: '22px' }} alt='LogoutIcon' />{' '}
        Logout
      </li>
    </ul>
  )

  function handleVisible() {
    setVisible(!visible)
  }

  function handleChangePassword(values, resetForm) {
    const queryVariables = _omit(values, 'confirm')
    client
      .mutate({ mutation: CHANGE_PASSWORD, variables: queryVariables })
      .then((res) => {
        openNotification('success', 'Password Changed Successfully')
        handleVisible()
        resetForm()
        history.push('/logout')
      })
      .catch((err) => console.log(err))
  }

  const readUpdateNotification = (isAllRead, id, index) => {
    let where = {}
    let data = { isRead: true, limit: notifications?.length }
    if (isAllRead) {
      setReadAllLoading(true)
      data = { ...data, isAllRead }
    } else {
      setReadLoading((curr) => {
        return { ...curr, [index]: true }
      })
      where = { ...where, id: parseInt(id) }
    }

    client
      .mutate({ mutation: READ_NOTIFICATION, variables: { data, where } })
      .then((res) => {
        dispatch({
          type: 'ALL_NOTIFICATIONS_FOR_CLIENT',
          data: res?.data?.readNotification,
        })
        setReadAllLoading(false)
        setReadLoading((curr) => {
          return { ...curr, [index]: false }
        })
      })
      .catch((err) => {
        console.log(err)
        setReadAllLoading(false)
        setReadLoading((curr) => {
          return { ...curr, [index]: false }
        })
      })
  }

  const loadMoreNotifications = () => {
    setLoadMoreLoading(true)
    client
      .query({
        query: GET_ALL_NOTIFICATION_FOR_CLIENT,
        variables: { limit: notifications?.length + 10 },
        fetchPolicy: 'network-only',
      })
      .then((res) => {
        dispatch({
          type: 'ALL_NOTIFICATIONS_FOR_CLIENT',
          data: res?.data?.getNotifications,
        })
        setLoadMoreLoading(false)
      })
      .catch((err) => {
        console.log(err)
        setLoadMoreLoading(false)
      })
  }

  const notificationMenu = (
    <div>
      {notifications?.length ? (
        <div style={{ maxHeight: '700px', overflow: 'auto' }}>
          {notifications.map((item, index) => {
            return (
              <div
                onClick={() => {
                  if (!item?.isRead && !readLoading[index]) {
                    readUpdateNotification(false, item?.id, index)
                  }
                }}
                style={{ display: 'flex', alignItems: 'center' }}
              >
                <div
                  key={item.id}
                  className={
                    item?.isRead
                      ? 'notification-card-read'
                      : 'notification-card'
                  }
                >
                  <div className='notification-content'>
                    <img
                      src={
                        item?.type?.includes('TICKET')
                          ? TicketIcon
                          : item?.type === 'ADVISORY'
                          ? AdvisoryIcon
                          : PendingAdvisoryIcon
                      }
                      alt='LogoutIcon'
                      className='company-logo'
                    />
                    <div>
                      <h4
                        className={
                          item?.isRead
                            ? 'notification-title-read'
                            : 'notification-title'
                        }
                      >
                        {item?.title}
                      </h4>
                    </div>
                  </div>
                  <div
                    className='notification-footer'
                    style={{ display: 'flex', justifyContent: 'space-between' }}
                  >
                    <div>
                      {item?.type === 'TICKET_CHAT_MENTION' && (
                        <span
                          style={{
                            cursor: 'pointer',
                            color: '#7e0a0a',
                            fontWeight: 'bold',
                            marginLeft: '42px',
                          }}
                          onClick={() =>
                            history.push(`/tickets/${item?.referenceId}`)
                          }
                        >{`Go to the chat >`}</span>
                      )}
                    </div>
                    <span>
                      {moment().format('DD-MM-YYYY') !==
                      moment(item?.createdAt).format('DD-MM-YYYY')
                        ? moment(item?.createdAt).format('DD-MM-YYYY h:mm A')
                        : moment(item?.createdAt).format('LT')}
                    </span>
                  </div>
                </div>
              </div>
            )
          })}

          <div className='notification_action_btns'>
            {notReadCount > 0 ? (
              <Button
                className='read_all_notification_btn'
                onClick={() => readUpdateNotification(true, null, null)}
                loading={readAllLoading}
              >
                Read all
              </Button>
            ) : (
              ''
            )}
            {count > notifications.length ? (
              <Button
                className='faq-btn'
                loading={loadMoreLoading}
                onClick={loadMoreNotifications}
              >
                Load more
              </Button>
            ) : (
              <></>
            )}
          </div>
        </div>
      ) : (
        <div className='no_notification'>No Notification Found</div>
      )}
    </div>
  )

  return (
    <Fragment>
      <Header
        className='header-new'
        role='banner'
        aria-label='Site Header'
        style={{ display: 'flex', justifyContent: 'space-between' }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            height: `${isMobile ? 'auto' : '100%'}`,
            alignItems: 'center',
            width: '100%',
          }}
        >
          {isClient && currentUser?.completedSteps !== 'DONE' ? (
            <div
              className={`${
                showFAQScreen
                  ? 'header-new-text-with-tag-description'
                  : 'header-new-text-with-tag'
              }`}
            >
              <div className='header-new-title'>
                {currentUser?.completedSteps === 'DONE'
                  ? window?.location?.pathname.replace('/', '')
                  : currentUser?.completedSteps === null
                  ? 'Disclaimer'
                  : showFAQScreen
                  ? 'FAQ'
                  : currentUser?.completedSteps === 'E_MANDATE' &&
                    currentUser?.isBookingAdvisoryDateSelected
                  ? 'Booked Advisory Slot'
                  : getIndividualStepTitle(currentUser?.completedSteps)}
              </div>
              {currentUser?.completedSteps === 'E_MANDATE' && showFAQScreen && (
                <div className='header-new-subtitle'>
                  Read some of he top queries asked by our customers
                </div>
              )}
              {(currentUser?.completedSteps === 'KYC_DOC' ||
                !currentUser?.isPanCardIndividual ||
                (currentUser?.completedSteps === 'CLIENT_PROFILE_2' &&
                  currentUser?.cvlStatus)) && (
                <div className='user-score-status'>
                  <Tag
                    defaultValue={clientRiskScore}
                    color='red'
                    className='red-tag'
                  >
                    <div className='risk-score-div'>
                      <span className='risk-score-text'>Risk Score </span>
                      <span className='risk-score-total'>
                        {clientRiskScore}
                      </span>
                    </div>
                  </Tag>
                  <Tag
                    className={`${
                      currentUser?.cvlStatus ? 'green-tag' : 'red-tag'
                    }`}
                    // style={{
                    //   padding: '16px',
                    // }}
                  >
                    <div className='risk-score-div'>
                      <span
                        className={`${
                          currentUser?.cvlStatus
                            ? 'risk-score-text-green'
                            : 'risk-score-text'
                        }`}
                      >
                        PAN KYC Status
                      </span>{' '}
                      <span
                        className={`${
                          currentUser?.cvlStatus
                            ? 'risk-score-total-green'
                            : 'risk-score-total'
                        }`}
                      >
                        ({currentUser?.cvlStatus ? 'YES' : 'NO'})
                      </span>
                    </div>
                  </Tag>
                </div>
              )}
            </div>
          ) : (
            <Breadcrumb
              separator='>'
              style={{ display: 'flex', flexWrap: 'wrap' }}
            >
              <Breadcrumb.Item>
                <img src={HomeNewIcon} alt='' />
              </Breadcrumb.Item>
              {window.location.pathname === '/' ? (
                <Breadcrumb.Item
                  href=''
                  style={{
                    textTransform: 'capitalize',
                    color: '#3F4254',
                    fontSize: `${isMobile ? '12px' : '14px'}`,
                    fontWeight: '600',
                    lineHeight: '14px',
                    textAlign: 'left',
                  }}
                >
                  Dashboard
                </Breadcrumb.Item>
              ) : (
                window.location.pathname.split('/')?.map((item) => {
                  return (
                    <Breadcrumb.Item
                      href=''
                      style={{
                        textTransform: 'capitalize',
                        color: '#3F4254',
                        fontSize: `${isMobile ? '12px' : '14px'}`,
                        fontWeight: '600',
                        lineHeight: '14px',
                        textAlign: 'left',
                      }}
                    >
                      {item}
                    </Breadcrumb.Item>
                  )
                })
              )}
            </Breadcrumb>
          )}
          <div className='header-new-info'>
            {(currentUser?.role === 'CLIENT' || !currentUser) && renderAswToolbar()}
            {currentUser?.role !== 'CLIENT' ? (
              <div
                style={{
                  display: `${isMobile ? 'none' : 'flex'}`,
                  gap: '10px',
                }}
              >
                {showFilters && (
                  <Select
                    getPopupContainer={(trigger) => trigger.parentElement}
                    placeholder='Select Group'
                    className='display-field'
                    onChange={(value, title) => {
                      if (value === undefined) {
                        dispatch({
                          type: 'SELECTED_ASSOCIATE',
                          data: undefined,
                        })
                        dispatch({
                          type: 'SELECTED_GROUP',
                          data: undefined,
                        })
                        setSelectedUserName(undefined)
                      } else {
                        setSelectedUserName(title?.title)
                        dispatch({
                          type: 'SELECTED_GROUP',
                          data: value ? parseInt(value) : undefined,
                        })
                        dispatch({
                          type: 'SELECTED_ASSOCIATE',
                          data: undefined,
                        })
                        setSelectedUserId('')
                        setSelectedGroupId(value)
                      }
                    }}
                    style={{ width: !isMobile ? 200 : 150 }}
                    loading={userDataLoading}
                    disabled={userDataLoading}
                    value={selectedUserName || undefined}
                    open={open}
                    onDropdownVisibleChange={(visible) => setOpen(visible)}
                    allowClear={true}
                  >
                    {returnGroups()}
                  </Select>
                )}
                {showFilters && (
                  <Select
                    getPopupContainer={(trigger) => trigger.parentElement}
                    placeholder='Select Strategy'
                    defaultValue={'ILTS'}
                    style={{ width: 94 }}
                    className='display-field'
                    onChange={(e) =>
                      dispatch({ type: 'SELECTED_STRATEGY', data: e })
                    }
                  >
                    {_map(strategyList, (strategy, key) => {
                      const { StrategyName } = strategy
                      return (
                        <Option value={StrategyName} key={key}>
                          {StrategyName}
                        </Option>
                      )
                    })}
                  </Select>
                )}
              </div>
            ) : (
              <div className='faqs-icon-div'>
                <Button
                  style={{ display: `${isMobile ? 'none' : 'flex'}` }}
                  className='faq-btn'
                  onClick={() => {
                    if (currentUser?.completedSteps !== 'DONE') {
                      dispatch({ type: 'SHOW_FAQ_SCREEN', data: true })
                    } else {
                      history.push('/faqs')
                    }
                  }}
                >
                  Help&nbsp;
                </Button>
              </div>
            )}
            <Popover
              placement='bottomRight'
              onVisibleChange={() => setVisibleMenu(!visibleMenu)}
              visible={visibleMenu}
              content={userMenuOptions}
              trigger='click'
              className='header-popover'
            >
              <div className='header-new-user-avatar-container'>
                <div className='header-new-user-avatar'>
                  {currentUser?.role === 'ADMIN'
                    ? currentUser?.firstName[0]
                    : !currentUser?.isPanCardIndividual &&
                      currentUser?.nameOfApplicant?.length
                    ? currentUser?.nameOfApplicant?.split(' ')?.length > 1
                      ? currentUser?.nameOfApplicant[0] +
                        currentUser?.nameOfApplicant?.split(' ')[1][0]
                      : currentUser?.nameOfApplicant[0]
                    : currentUser?.firstName || currentUser?.lastName
                    ? `${currentUser?.firstName?.[0] || ''}${
                        currentUser?.lastName
                          ? ' ' + currentUser.lastName[0]
                          : ''
                      }`
                    : '-'}
                </div>
                <div className='header-new-user-info'>
                  <div className='header-new-user-name'>
                    {currentUser?.role === 'ADMIN'
                      ? currentUser?.firstName
                      : !currentUser?.isPanCardIndividual &&
                        currentUser?.nameOfApplicant
                      ? currentUser?.nameOfApplicant
                      : currentUser?.firstName || currentUser?.lastName
                      ? `${currentUser?.firstName} ${
                          currentUser?.lastName ? currentUser?.lastName : ''
                        }`
                      : ''}
                  </div>
                  {currentUser?.clientCode ? (
                    <div className='header-new-user-code'>
                      {currentUser?.clientCode}
                    </div>
                  ) : currentUser?.currentType === 'Master Associate' ? (
                    <div className='header-new-user-code'>
                      {currentUser?.currentType}
                    </div>
                  ) : (
                    <div className='header-new-user-code'>
                      {currentUser?.role === 'SALES_EXECUTIVE'
                        ? 'AIF_SALES_EXECUTIVE'.split('_')?.join(' ')
                        : currentUser?.role.split('_')?.join(' ')}
                    </div>
                  )}
                </div>
                <i
                  className='icon icon-chevron-down gx-fs-xxs'
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    fontSize: '15px',
                    color: '#000',
                  }}
                />
              </div>
            </Popover>
            <div
              style={{ display: `${isMobile ? 'none' : 'flex'}` }}
              className='header-new-logout-container'
              onClick={() => {
                client
                  .mutate({
                    mutation: UPDATE_USER,
                    variables: {
                      data: {
                        token: null,
                        tokenExpiration: null,
                      },
                      id: parseInt(currentUser.id),
                    },
                  })
                  .then((res) => {
                    window.location.href = '/logout'
                  })
              }}
            >
              <img src={LogoutIcon} alt='LogoutIcon' />
              <div className='header-new-logout-text'>Logout</div>
            </div>

            <Popover
              placement='bottomLeft'
              onVisibleChange={() => setIsNotificationOpen(!isNotificationOpen)}
              trigger='click'
              visible={isNotificationOpen}
              content={notificationMenu}
              overlayClassName='notification-popover'
              overlayStyle={{ width: '350px' }}
            >
              <div className='header-new-logout-container'>
                <img
                  className='notification_icon'
                  src={NotificationIcon}
                  alt='LogoutIcon'
                />
                {notReadCount > 0 && (
                  <div className='notification_counter'>
                    {notReadCount > 50 ? '50+' : notReadCount}
                  </div>
                )}
              </div>
            </Popover>
          </div>
        </div>

        {(currentUser?.completedSteps === 'KYC_DOC' ||
          (!currentUser?.isPanCardIndividual &&
            currentUser?.completedSteps === 'CLIENT_PROFILE_2')) && (
          <div className='user-score-status-mobile'>
            <Tag defaultValue={clientRiskScore} color='red' className='red-tag'>
              <div className='risk-score-div'>
                <span className='risk-score-text'>Risk Score </span>
                <span className='risk-score-total'>{clientRiskScore}</span>
              </div>
            </Tag>
            <Tag
              className={`${currentUser?.cvlStatus ? 'green-tag' : 'red-tag'}`}
              // style={{
              //   padding: '16px',
              // }}
            >
              <div className='risk-score-div'>
                <span
                  className={`${
                    currentUser?.cvlStatus
                      ? 'risk-score-text-green'
                      : 'risk-score-text'
                  }`}
                >
                  PAN KYC Status
                </span>{' '}
                <span
                  className={`${
                    currentUser?.cvlStatus
                      ? 'risk-score-total-green'
                      : 'risk-score-total'
                  }`}
                >
                  ({currentUser?.cvlStatus ? 'YES' : 'NO'})
                </span>
              </div>
            </Tag>
          </div>
        )}

        {currentUser?.role !== 'CLIENT' && (
          <div
            style={{
              display: `${isMobile ? 'flex' : 'none'}`,
              marginTop: '10px',
              gap: '20px',
            }}
          >
            {showFilters && (
              <Select
                getPopupContainer={(trigger) => trigger.parentElement}
                placeholder='Select Client'
                className='display-field'
                onChange={(value) =>
                  dispatch({
                    type: 'SELECTED_GROUP',
                    data: value ? parseInt(value) : undefined,
                  })
                }
                style={{ width: 133 }}
              >
                <Option value=''>All Clients</Option>
                {returnGroups()}
              </Select>
            )}
            {showFilters && (
              <Select
                getPopupContainer={(trigger) => trigger.parentElement}
                defaultValue='1005'
                style={{ width: 94 }}
                className='display-field'
                onChange={(e) =>
                  dispatch({ type: 'SELECTED_STRATEGY', data: e })
                }
              >
                {_map(strategyList, (strategy, key) => {
                  const { StrategyName, StrategyCode } = strategy
                  return (
                    <Option value={StrategyCode} key={key}>
                      {StrategyName}
                    </Option>
                  )
                })}
              </Select>
            )}
          </div>
        )}
      </Header>
      {visible && (
        <ChangePassword
          visible={visible}
          onCreate={handleChangePassword}
          onCancel={handleVisible}
        />
      )}
      {isClient && isActive && (
        <div role='region' aria-label='System Message' aria-live='polite'>
          <Row gutter={24}>
            <Col span={24}>
              <div style={messageStyle}>{message}</div>
            </Col>
          </Row>
        </div>
      )}
    </Fragment>
  )
}

export default HeaderNew
